module.exports = __webpack_public_path__ + "a7fed757b36165ecbaf5a56a8f9e7726.pdf";